import React from 'react';

const ratingStarIcon = (width,height,color) =>
    <svg width={width ? width:'25'} height={height ? height:'25'} viewBox='0 0 24 24' fill={color ? color:'#fff'} xmlns='http://www.w3.org/2000/svg'>
        <path d='M19.51,9.24a1.65,1.65,0,0,0-.94-2.81l-4.44-.68h0a.73.73,0,0,1-.52-.39L11.67,1.23a1.63,1.63,0,0,0-3,0L6.77,5.39a.73.73,0,0,1-.52.39L1.8,6.47A1.65,1.65,0,0,0,.87,9.28l3.28,3.37h0a.72.72,0,0,1,.2.62l-.77,4.68A1.66,1.66,0,0,0,5.2,19.89,1.69,1.69,0,0,0,6,19.64l3.87-2.15a.71.71,0,0,1,.67,0l3.89,2.15a1.61,1.61,0,0,0,1.72-.09,1.64,1.64,0,0,0,.68-1.62L16,13.25a.69.69,0,0,1,.2-.61Z' transform='translate(-0.37 -0.28)'/>
    </svg>;

export default ratingStarIcon;
